import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import SelectWithSearch from "components/select-with-search";
import { ReactComponent as OutlineChevronDown } from "assets/svg/outline-chevron-down-16.svg";
import { ReactComponent as OutlineCross16 } from "assets/svg/outline-cross-16.svg";
import styles from "./styles.module.scss";

const DropdownWithSearch = ({
  data,
  fieldChangedCallback,
  fieldName,
  options,
  placeholder,
  onClick,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([] as any);

  useEffect(() => {
    if (data) {
      setSelected(options.filter((option) => data.includes(option.value)));
    }
  }, [data, options]);

  const onSelectChange = (selected) => {
    const values = selected?.map((el) => el.value);
    fieldChangedCallback(fieldName, values);
  };

  return (
    <div className={"position-relative"}>
      <Button
        variant="outline-primary"
        className={styles["dropdown-w-search__dropdown-toggle"]}
        onClick={() => {
          onClick();
          setOpen(!open);
        }}
        {...props}
      >
        <div className={styles["dropdown-w-search__dropdown-toggle-left"]}>
          {selected.length > 0 ? (
            selected.map((option) => (
              <div
                key={option?.value}
                className={styles["dropdown-w-search__selected"]}
              >
                {option?.label}
                <span
                  className={"ml-1"}
                  onClick={(e) => {
                    e.stopPropagation();
                    const nextSelected = selected.filter(
                      (el) => el.value !== option.value,
                    );
                    setSelected(nextSelected);
                    onSelectChange(nextSelected);
                  }}
                >
                  <OutlineCross16 />
                </span>
              </div>
            ))
          ) : (
            <div className={styles["dropdown-w-search__selected--empty"]}>
              {placeholder ? placeholder : "Select all that apply"}
            </div>
          )}
        </div>
        <div className={styles["dropdown-w-search__dropdown-toggle-right"]}>
          <OutlineChevronDown className="gray01" />
        </div>
      </Button>
      {open ? (
        <div className={styles["dropdown-w-search__dropdown-menu"]}>
          <SelectWithSearch
            isOptionDisabled={selected.length >= 10}
            onChange={(values) => {
              setSelected(values);
              onSelectChange(values);
            }}
            options={options}
            value={selected}
            placeholder={placeholder}
          />
        </div>
      ) : null}
      {open ? <Blanket onClick={() => setOpen(!open)} /> : null}
    </div>
  );
};

const Blanket = (props) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1,
    }}
    {...props}
  />
);

export default DropdownWithSearch;
